export const useArrayToRGB = (colorArray: number[]) => {
  if (colorArray.length !== 3) {
    return "rgb(0,0,0)";
  }

  // If any of the values in the colorArray are not numbers, less than 0 orr greater than 255, return "rgb(0,0,0)"
  if (
    colorArray.some(
      (value) => typeof value !== "number" || value < 0 || value > 255
    )
  ) {
    return "rgb(0,0,0)";
  }

  return `rgb(${colorArray[0]}, ${colorArray[1]}, ${colorArray[2]})`;
};
